export default "__VITE_ASSET__DvBNGg3s__"